import React, { useEffect } from 'react';
import ReactDOM from 'react-dom'
import { InsertDriveFile } from '@mui/icons-material';
import StandardModal from '~/components/StandardModal';
import { useLang } from '~/hooks/useLang';
import { useHookstate, useState } from '@hookstate/core';
import useSystemState from '~/features/System/stores/SystemState';
import SearchVehicle from '~/features/Vehicle/components/SearchVehicle';
import { authFetch } from '~/services/fetch';
import { useLocation } from 'react-router';
import ScreenSettingsDraggableProps from '~/features/Entry/interfaces/IPositionDraggable';
import { storeScreenSettings } from '~/features/System/services';

const modal = document.getElementById('div-modal') as HTMLElement;

export default function SearchVehicleModalDraggable() {
  const { translate } = useLang();
  const { windowManager, loadingButton } = useSystemState();
  const loadingComponent = useHookstate(true)
  const getPositionsDraggable = useHookstate<ScreenSettingsDraggableProps>({
    id: 0,
    user_id: 0,
    url: '',
    window_name: '',
    x_position: 80,
    y_position: 141,
    is_window_open: true,
    is_window_minimized: false,
    created_at: new Date().toJSON(),
    updated_at: new Date().toJSON(),
    deleted_at: null
  })

  const handleStop = (event, dragElement) => {
    event.stopPropagation();
    event.preventDefault();

    getPositionsDraggable.x_position.set(dragElement.x);
    getPositionsDraggable.y_position.set(dragElement.y);
  };

  useEffect(() => {
    authFetch({
      url: '/screen-setting/get-user-settings',
      method: 'POST',
      data: {
        url: location.pathname,
      }
    }).then((response) => {
      if ('SearchVehicleModalDraggable' in response.data) {
        getPositionsDraggable.set(response.data.SearchVehicleModalDraggable)
      }
      loadingComponent.set(false)
    })

    return () => {
      windowManager()['searchVehicle'].open.set(false)
    }
  }, [])


  useEffect(() => {
    return () => {
      storeScreenSettings({
        windowName: 'SearchVehicleModalDraggable',
        isOpen: windowManager()['searchVehicle'].open.get(),
        isMinimized: getPositionsDraggable.is_window_minimized?.get(),
        positionX: getPositionsDraggable?.x_position?.get(),
        positionY: getPositionsDraggable?.y_position?.get(),
      })
    }
  }, [
    windowManager()['searchVehicle'].open.get(),
    getPositionsDraggable.is_window_minimized?.get(),
    getPositionsDraggable?.x_position?.get(),
    getPositionsDraggable?.y_position?.get(),
  ])



  if (windowManager()['searchVehicle'].open.get()) {
    return ReactDOM.createPortal(
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {!loadingButton.get() && !loadingComponent.get() &&
          <StandardModal
            title={`${translate("Search Vehicles")}`}
            avatar={InsertDriveFile}
            dimensions={{
              width: 400
            }}
            isExpanded={getPositionsDraggable.is_window_minimized}
            handleStop={handleStop}
            position={{
              x: getPositionsDraggable?.x_position?.get() ? Number(getPositionsDraggable?.x_position?.get()) : 250,
              y: getPositionsDraggable?.y_position?.get() ? Number(getPositionsDraggable?.y_position?.get()) : 100
            }}
            closeButton={!(windowManager()['searchVehicle'].disabled.value) ? () => {
              windowManager()['searchVehicle'].open.set(false)
              windowManager()['searchVehicle'].dataSearchVehicle.set([])
            } : false}
          >
            <SearchVehicle />
          </StandardModal>
        }
      </>
      , modal);
  } else {
    return <></>
  }
}
